import { inject, injectable } from 'inversify';
import {
  InjectionSymbols as LoggerInjectionSymbols,
  type Logger,
} from '@hitiq/logger';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { UpdateUserInput, User, UserBackend } from './users.interfaces';
import { defaultSelectors, defaultDispatchers } from './users.slice';
import { ReduxRepository } from '../reduxRepository';
import { UserTranslator } from './user.translator';
import { updateUserThunk } from './userUpdate.thunk';
import { deleteUserThunk } from './userDelete.thunk';
import { createUserThunk } from './userCreate.thunk';
import { loadUserThunk } from './userLoad.thunk';
import { store } from '../../store';

@injectable()
export class UserRepository extends ReduxRepository<User, UserBackend> {
  constructor(
    @inject(LoggerInjectionSymbols.LOGGER)
    protected readonly loggingService: Logger,
    protected readonly datastore: AmplifyDataStore<UserBackend>,
  ) {
    super(
      ModelTypes.User,
      new UserTranslator(),
      datastore,
      loggingService,
      defaultSelectors,
      defaultDispatchers,
      createUserThunk,
      updateUserThunk,
      deleteUserThunk,
      loadUserThunk,
    );
  }

  dispatchUpdate(resourceChange: UpdateUserInput): void {
    if (!this.user) {
      console.error('should never get here. Need to set a user');
      return;
    }

    store.dispatch(
      this.updateThunk({
        resourceChange,
      }),
    );
  }

  dispatchDelete(id: string): void {
    store.dispatch(
      this.deleteThunk({
        id,
      }),
    );
  }
}
